import { BasicActionDialog } from 'features/ui/base-dialogs';
import PaiTextField from 'features/ui/base-components/pai-text-field';
import React from 'react';

interface Props {
  open: boolean;
  newSubFolderName: string;

  handleLeadTagSubFolderNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleCloseAddLeadTagSubFolderDialog(): void;

  handleAddLeadTagSubFolder(): void;
}

const AddSubFolderDialog: React.FC<Props> = ({
  open,
  newSubFolderName,
  handleLeadTagSubFolderNameChange,
  handleCloseAddLeadTagSubFolderDialog,
  handleAddLeadTagSubFolder,
}) => {
  return (
    <BasicActionDialog
      open={open}
      dialogTitle={'Unterordner hinzufügen'}
      maxWidth={'xs'}
      cancelButtonText={'Abbrechen'}
      proceedButtonText={'Hinzufügen'}
      handleClose={handleCloseAddLeadTagSubFolderDialog}
      handleProceed={handleAddLeadTagSubFolder}
    >
      <PaiTextField value={newSubFolderName} placeholder={'Hier Name des Unterordner eingeben...'} onChange={handleLeadTagSubFolderNameChange} />
    </BasicActionDialog>
  );
};

export default AddSubFolderDialog;
